import type { Follow } from '../../types/following';
import asSubEventMap from './utils/asSubEventMap';
import asResultCodeMap from './utils/asResultCodeMap';

export type FollowingState = {
  following: Follow[];
  followsBySubEventId: Record<number, Follow[]>;
  followsByResultCode: Record<string, Follow>;
  focussed?: Follow;
  status?: 'initialized';
};

export type FollowingStateAction =
  | { type: 'initialize'; payload?: Follow[] }
  | { type: 'setFollows'; payload?: Follow[] }
  | { type: 'focus'; payload?: string }
  | { type: 'reset'; payload: undefined };

const followingReducer = (state: FollowingState, action: FollowingStateAction): FollowingState => {
  const { type, payload } = action;
  switch (type) {
    case 'initialize':
      return {
        ...state,
        following: payload ?? [],
        followsBySubEventId: asSubEventMap(payload ?? []),
        followsByResultCode: asResultCodeMap(payload ?? []),
        status: 'initialized',
      };

    case 'setFollows':
      return {
        ...state,
        following: payload ?? [],
        followsBySubEventId: asSubEventMap(payload ?? []),
        followsByResultCode: asResultCodeMap(payload ?? []),
        status: 'initialized',
      };

    case 'reset': {
      return {
        ...state,
        following: [],
        followsBySubEventId: {},
        followsByResultCode: {},
        focussed: undefined,
        status: undefined,
      };
    }

    case 'focus': {
      const focussed = state.followsByResultCode[payload ?? ''];
      return {
        ...state,
        focussed,
      };
    }

    default:
      return state;
  }
};

export default followingReducer;
